'use client';

import { CalendarPlus } from 'lucide-react';
import type { OpenHouse } from '@/types/listing';
import { buildOpenHouseIcs, downloadIcs } from '@/lib/ics';

interface AddToCalendarProps {
  openHouse: OpenHouse;
  address: string;
  city: string;
  state: string;
  zip: string;
}

export default function AddToCalendar({ openHouse, address, city, state, zip }: AddToCalendarProps) {
  const handleClick = () => {
    const ics = buildOpenHouseIcs({
      address,
      city,
      state,
      zip,
      date: openHouse.date,
      startTime: openHouse.start_time,
      endTime: openHouse.end_time,
      url: window.location.href,
    });
    downloadIcs(`open-house-${openHouse.date.slice(0, 10)}.ics`, ics);
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1.5 text-sm font-medium text-emerald-300 transition-colors hover:text-emerald-700"
    >
      <CalendarPlus className="h-4 w-4" />
      Add to calendar
    </button>
  );
}
